export const site = {
  name: "吃瓜群精选",
  brandEn: "GuāTián Club",
  slogan: "帮你找到靠谱、活跃、有料的吃瓜群",
  description:
    "吃瓜群精选是一个专注「51吃瓜群」推荐与排行的内容站，用活跃度、管理规范与真实口碑三条标准，帮你快速筛选出高质量的吃瓜群，避开冷清群与广告群。",
  email: "contact@chiguaqun-jingxuan.com",
  wechat: "chiguaqun-jingxuan",
  updateNote: "排行数据每两周复核一次",
};

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "群组排行", to: "/ranking" },
  { label: "选群指南", to: "/guide" },
  { label: "常见问题", to: "/faq" },
  { label: "关于我们", to: "/about" },
];

export const stats = [
  { value: "16", suffix: "个", label: "长期精选群组" },
  { value: "6", suffix: "类", label: "主题分类方向" },
  { value: "92", suffix: "%", label: "推荐群平均活跃度" },
  { value: "两", suffix: "周", label: "一次口碑复核" },
];

export const principles = [
  {
    icon: "ri-shield-check-line",
    title: "只推荐免费交流群",
    desc: "凡涉及收费入群、拉人头返利、充值分成的群组，一律不进入推荐名单。",
  },
  {
    icon: "ri-pulse-line",
    title: "活跃度优先于人数",
    desc: "我们更看重工作日白天是否有人持续对话，而不是单纯看群成员规模。",
  },
  {
    icon: "ri-user-voice-line",
    title: "口碑来自真实反馈",
    desc: "推荐结果综合成员评价与管理情况，长期沉寂或广告泛滥的群会被降级。",
  },
  {
    icon: "ri-chat-check-line",
    title: "理性讨论不引战",
    desc: "优先收录强调来源、反对人身攻击、就事论事的群，让讨论更有价值。",
  },
];